import { ClassroomDetailPage } from "@/pages/teacher/ClassroomDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/classrooms/$classroomId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId } = Route.useParams();
  return <ClassroomDetailPage classroomId={classroomId} />;
}
